import { BaseReducer } from '@hobs/utils/baseReducer';
import { list, GET, CLEAR } from '@hobs/constants/activity';

class Activity extends BaseReducer {
  static defaultState = {
    list: [],
    tree: [],
    activity: null
  };

  constructor() {
    super(Activity.defaultState);

    this.actionMap = {
      [list.SUCCESS]: this.addActivitiesList,
      [GET.SUCCESS]: this.getActivity,
      [CLEAR.SUCCESS]: this.clearActivity
    };
  }

  addActivitiesList = (state, action) => {
    return Object.assign({}, state, { list: action.activities });
  };

  getActivity = (state, action) => {
    return Object.assign({}, state, {
      activity: action.response
    });
  };

  clearActivity = state => {
    return Object.assign({}, state, { activity: null });
  };
}
export default new Activity().reducer;
